import { Card, CardHeader, IconButton, Collapse, CircularProgress } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import React, { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ClientHistoryProps } from './client-history';

const LazyLoadClientHistory = React.lazy(() => import('./client-history'));

const LazyLoadedClientHistory: React.FC<ClientHistoryProps> = (props) => {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();
    return (
        <>
            <Card sx={{ width: '100%', border: '1px solid rgba(211,211,211,0.6)' }}>
                <CardHeader
                    title={t('viewHistory')}
                    action={
                        <IconButton onClick={() => setOpen(!open)} aria-label="expand" size="small">
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    }
                ></CardHeader>
                <div style={{ backgroundColor: 'rgba(211,211,211,0.4)' }}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Suspense fallback={<CircularProgress color="inherit" />}>
                            <LazyLoadClientHistory {...props} />
                        </Suspense>
                    </Collapse>
                </div>
            </Card>
        </>
    );
};

export default LazyLoadedClientHistory;
